import React from "react";
import { Grid, Paper, Typography, Avatar, Box } from "@mui/material";
import { useLocation, Link } from "react-router-dom";

import ReactSSR from "./ReactSSR";
// AdBanner removed
import TailwindTutorial from "./TailwindCss";
import ReactGoDaddy from "./ReactGoDaddy";
import BacklinksImportance from "./BacklinksImportance";
import LongTailKeywordOptimization from "./LongTailKeywordOptimization";
import SecureTextSharing from "./SecureTextSharing";
import QRCodeTextSharing from "./QRCodeTextSharing";
// OnlineTextEditor removed
import AnonymousTextPublishing from "./AnonymousTextPublishing";
import CodeSnippetSharing from "./CodeSnippetSharing";
import PastebinAlternatives from "./PastebinAlternatives";
import ProgrammerProductivityTools from "./ProgrammerProductivityTools";
import ShareTextWithoutLogin from "./ShareTextWithoutLogin";
import WhereToShareTextOnline from "./WhereToShareTextOnline";
import FastNoteSharing from "./FastNoteSharing";
import lock from "../../assets/images/blog/lock.png";

import ReactssrImg from "../../assets/images/blog/Reactssr1.webp";
import webLinkImg from "../../assets/images/blog/backLink.png";
import codes from "../../assets/images/blog/codes.png";

import secureTextSharingToolsRemoteTeams from "../../assets/images/blog/secureTextSharingToolsRemoteTeams.png";
import bestFree from "../../assets/images/blog/BestFree.jpg";

import tailwindcss from "../../assets/images/blog/Tailwindcss1.webp";
import longTail from "../../assets/images/blog/longTail.jpeg";
import qr from "../../assets/images/blog/qrBlog.png";

import godaddyhostingweb from "../../assets/images/blog/godaddy_hosting_web.webp";

const BlogPage = () => {
  const location = useLocation();

  const yourListOfPosts = [
    {
      id: 1,
      title: "Reactjs Server Side Rendering - Implement react ssr",
      date: "2024-01-01",
      url: "/blog/react-ssr-seo-react-helmet",
      imageUrl: ReactssrImg,
    },
    {
      id: 2,
      title: "Learn Tailwindcss with Responsive Website | nextjs",
      date: "2024-01-02",
      url: "/blog/tailwindcss",
      imageUrl: tailwindcss,
    },
    {
      id: 3,
      title: "GoDaddy Domain to Hostinger Hosting",
      date: "2024-07-26",
      url: "/blog/godaddy-hosting-web",
      imageUrl: godaddyhostingweb,
    },
    {
      id: 4,
      title: "The Importance of Backlinks: How JustPaste.it Helps Build Quality Backlinks",
      date: "2025-09-15",
      url: "/blog/importance-of-backlinks-justpaste",
      imageUrl: webLinkImg,
    },
    {
      id: 5,
      title: "Advanced Long-Tail Keyword Optimization: Complete SEO Strategy Guide for 2025",
      date: "2025-09-16",
      url: "/blog/advanced-long-tail-keyword-optimization-seo-guide",
      imageUrl: longTail,
    },
    {
      id: 6,
      title: "How to Share Text Online Securely: Free Text Sharing Tools for Remote Teams in 2025",
      date: "2025-09-24",
      url: "/blog/secure-text-sharing-tools-remote-teams",
      imageUrl: secureTextSharingToolsRemoteTeams,
    },
    {
      id: 7,
      title: "Best Free QR Code Generator for Text Sharing: Complete Guide to Mobile-Friendly Content Sharing",
      date: "2025-09-24",
      url: "/blog/free-qr-code-generator-text-sharing-mobile",
      imageUrl: qr,
    },
    {
      id: 8,
      title: "Best Free Online Text Editor with Rich Formatting: Complete Guide to Web-Based Document Creation",
      date: "2025-09-24",
      url: "/blog/free-online-text-editor-rich-formatting-guide",
      imageUrl: bestFree,
    },
    {
      id: 9,
      title: "Text Publishing Platform: Complete Guide to Secure Anonymous Content Sharing in 2025",
      date: "2025-09-24",
      url: "/blog/anonymous-text-publishing-platform-secure-content-sharing",
      imageUrl: lock,
    },
    {
      id: 10,
      title: "The Ultimate Guide to Code Snippet Sharing: Syntax Highlighting and Instant Collaboration for Developers",
      date: "2025-06-10",
      url: "/blog/code-snippet-sharing-syntax-highlighting-developers",
      imageUrl: codes,
    },
    {
      id: 11,
      title: "Best Pastebin Alternatives in 2025: Complete Comparison of dpaste, Snippets, and Modern Text Sharing Tools",
      date: "2025-06-10",
      url: "/blog/best-pastebin-alternatives-dpaste-snippets-comparison",
      imageUrl: bestFree,
    },
    {
      id: 12,
      title: "Essential Programmer Tools for Maximum Productivity: Code Sharing, Snippets, and Collaboration Solutions",
      date: "2025-06-10",
      url: "/blog/programmer-productivity-tools-code-sharing-collaboration",
      imageUrl: codes,
    },
    {
      id: 13,
      title: "Share Online Text Without Login: The Ultimate Guide to Instant Text Sharing in 2025",
      date: "2025-01-10",
      url: "/blog/share-online-text-without-login",
      imageUrl: lock,
    },
    {
      id: 14,
      title: "Where to Share Text Online: Complete Guide to the Best Text Sharing Platforms in 2025",
      date: "2025-01-10",
      url: "/blog/where-to-share-text-online",
      imageUrl: bestFree,
    },
    {
      id: 15,
      title: "Fast Note Sharing Online: How to Share Notes Instantly Without CAPTCHA in 2026",
      date: "2026-07-15",
      url: "/blog/fast-note-sharing-instant-notepad-without-captcha",
      imageUrl: ReactssrImg,
    },
  ];

  return (
    <>
      {/* Hero Advertisement Space - Simple text format */}
      <Paper 
        sx={{ 
          minHeight: '200px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          border: '2px dashed #ccc',
          cursor: 'pointer',
          mb: 2,
          '&:hover': {
            backgroundColor: '#eeeeee',
            borderColor: '#999'
          }
        }}
        onClick={() => window.location.href = '/contact-us'}
      >
        <Typography 
          variant="h5" 
          sx={{ 
            color: '#666',
            fontWeight: 'bold',
            textAlign: 'center',
            mb: 1
          }}
        >
          Advertisement Space
        </Typography>
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#FF6B35',
            fontWeight: 'bold',
            fontSize: '1.5rem'
          }}
        >
          Just $1 for a month
        </Typography>
      </Paper>
      
      <Grid container spacing={3}>
        {/* Left Side - Post Content */}
        <Grid item xs={12} md={8}>
        {location &&
        (location.pathname === "/blog/react-ssr-seo-react-helmet" || location.pathname === "/") ? (
          <ReactSSR />
        ) : location.pathname === "/blog/godaddy-hosting-web" ? (
          <ReactGoDaddy />
        ) : location.pathname === "/blog/importance-of-backlinks-justpaste" ? (
          <BacklinksImportance />
        ) : location.pathname === "/blog/advanced-long-tail-keyword-optimization-seo-guide" ? (
          <LongTailKeywordOptimization />
        ) : location.pathname === "/blog/secure-text-sharing-tools-remote-teams" ? (
          <SecureTextSharing />
        ) : location.pathname === "/blog/free-qr-code-generator-text-sharing-mobile" ? (
          <QRCodeTextSharing />
        ) : location.pathname === "/blog/anonymous-text-publishing-platform-secure-content-sharing" ? (
          <AnonymousTextPublishing />
        ) : location.pathname === "/blog/code-snippet-sharing-syntax-highlighting-developers" ? (
          <CodeSnippetSharing />
        ) : location.pathname === "/blog/best-pastebin-alternatives-dpaste-snippets-comparison" ? (
          <PastebinAlternatives />
        ) : location.pathname === "/blog/programmer-productivity-tools-code-sharing-collaboration" ? (
          <ProgrammerProductivityTools />
        ) : location.pathname === "/blog/share-online-text-without-login" ? (
          <ShareTextWithoutLogin />
        ) : location.pathname === "/blog/where-to-share-text-online" ? (
          <WhereToShareTextOnline />
        ) : location.pathname === "/blog/fast-note-sharing-instant-notepad-without-captcha" ? (
          <FastNoteSharing />
        ) : (
          <TailwindTutorial />
        )}

        {/* Simple Advertisement Spaces */}
        <Grid container spacing={1} sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Paper 
              sx={{ 
                minHeight: '150px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
                border: '2px dashed #ccc',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#eeeeee',
                  borderColor: '#999'
                }
              }}
              onClick={() => window.location.href = '/contact-us'}
            >
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#666',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  mb: 1
                }}
              >
                Advertisement Space
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: '#FF6B35',
                  fontWeight: 'bold',
                  fontSize: '1.2rem'
                }}
              >
                Just $1 for a month
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Paper 
              sx={{ 
                minHeight: '150px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
                border: '2px dashed #ccc',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#eeeeee',
                  borderColor: '#999'
                }
              }}
              onClick={() => window.location.href = '/contact-us'}
            >
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#666',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  mb: 1
                }}
              >
                Advertisement Space
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: '#FF6B35',
                  fontWeight: 'bold',
                  fontSize: '1.2rem'
                }}
              >
                Just $1 for a month
              </Typography>
            </Paper>
          </Grid>
        </Grid>
        </Grid>

        {/* Right Side - Popular Posts List */}
        <Grid item xs={12} md={4}>
        {/* Sidebar Advertisement Space - Simple text format */}
        <Paper 
          sx={{ 
            minHeight: '250px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            border: '2px dashed #ccc',
            cursor: 'pointer',
            mb: 2,
            '&:hover': {
              backgroundColor: '#eeeeee',
              borderColor: '#999'
            }
          }}
          onClick={() => window.location.href = '/contact-us'}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              color: '#666',
              fontWeight: 'bold',
              textAlign: 'center',
              mb: 1
            }}
          >
            Advertisement Space
          </Typography>
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#FF6B35',
              fontWeight: 'bold',
              fontSize: '1.2rem'
            }}
          >
            Just $1 for a month
          </Typography>
        </Paper>
        
        <Paper sx={{ p: 3 }}>
          <Typography variant="h3" mb={2}>
            Popular Posts
          </Typography>
          {yourListOfPosts.map((post) => (
            <Link
              to={post.url}
              key={post.id}
              style={{ textDecoration: "none" }}
            >
              <Paper
                key={post.id}
                sx={{
                  cursor: "pointer",
                  p: 2,
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden", // Add overflow hidden to prevent horizontal scrolling
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                {/* Image Section (On the Right Side) */}
                <Avatar
                  src={post.imageUrl}
                  alt={post.title}
                  sx={{
                    marginLeft: 1,
                    marginRight: 2,
                    width: 80, // Adjust the width as needed
                    height: 60, // Adjust the height as needed
                    borderRadius: "10px", // Add rounded borders
                  }}
                />
                {/* Text Section (On the Left Side) */}
                <Box>
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: "1rem",
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography variant="caption">{post.date}</Typography>
                </Box>
              </Paper>
            </Link>
          ))}
        </Paper>
      </Grid>
    </Grid>
    </>
  );
};

export default BlogPage;
